export const CornerRadius = {
  CornetSharp: "0px",
  CornerS: "4px",
  CornerBase: "8px",
  CornerL: "12px",
};
